class ProductHotspots extends HTMLElement {
  constructor() {
    super();
    this.hotspots = this.querySelectorAll('.product-hotspots__hotspot');
    this.contents = this.querySelectorAll('.product-hotspots__content');
    this.imageWrapper = this.querySelector('.product-hotspots__image-wrapper');
    this.isMobile = window.innerWidth < 990;
    this.activeIndex = null;
    this.resizeObserver = null;

    this.init();
  }

  init() {
    this.bindEvents();
    this.calculateLines();
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  bindEvents() {
    // Hotspot events
    this.hotspots.forEach((hotspot) => {
      const dot = hotspot.querySelector('.product-hotspots__dot');

      // Mobile: click/tap events
      dot.addEventListener('click', (e) => this.handleTap(e, hotspot));
    });

    // Recalculate lines and handle mobile detection on resize
    this.resizeObserver = new ResizeObserver(() => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 990;

      // Reset states when switching between mobile and desktop
      if (wasMobile !== this.isMobile) {
        this.resetAllStates();
      }

      this.calculateLines();
    });

    if (this.imageWrapper) {
      this.resizeObserver.observe(this.imageWrapper);
    }
  }

  handleTap(event, hotspot) {
    if (!this.isMobile) return;

    event.preventDefault();
    const index = hotspot.dataset.hotspotIndex;
    const content = this.querySelector(`.product-hotspots__content[data-hotspot-index="${index}"]`);
    const dot = hotspot.querySelector('.product-hotspots__dot');

    // If tapping the same hotspot, toggle off
    if (this.activeIndex === index) {
      this.resetAllStates();
      return;
    }

    // Reset previous states
    this.resetAllStates();

    // Activate new hotspot and content
    this.activeIndex = index;
    hotspot.classList.add('is-active');
    if (dot) dot.setAttribute('aria-expanded', 'true');

    if (content) {
      content.classList.add('is-visible');

      // Smooth scroll to content
      setTimeout(() => {
        content.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 100);
    }
  }

  resetAllStates() {
    this.activeIndex = null;
    this.classList.remove('product-hotspots--has-active');

    this.hotspots.forEach((h) => {
      h.classList.remove('is-active');
      const dot = h.querySelector('.product-hotspots__dot');
      if (dot) dot.setAttribute('aria-expanded', 'false');
    });
    this.contents.forEach((c) => {
      c.classList.remove('is-active');
      c.classList.remove('is-visible');
    });
  }

  calculateLines() {
    if (this.isMobile) return;

    const gap = 16; // Gap between line end and content (in pixels)

    this.hotspots.forEach((hotspot) => {
      const index = hotspot.dataset.hotspotIndex;
      const content = this.querySelector(`.product-hotspots__content[data-hotspot-index="${index}"]`);
      const line = hotspot.querySelector('.product-hotspots__line line');

      if (!content || !line) return;

      const hotspotRect = hotspot.getBoundingClientRect();
      const contentRect = content.getBoundingClientRect();
      const contentSide = hotspot.dataset.contentSide;

      // Calculate horizontal endpoint on content block
      let contentX;

      if (contentSide === 'left') {
        // Line goes toward the right edge of the left content, with gap
        contentX = contentRect.right - hotspotRect.left - hotspotRect.width / 2 + gap;
      } else {
        // Line goes toward the left edge of the right content, with gap
        contentX = contentRect.left - hotspotRect.left - hotspotRect.width / 2 - gap;
      }

      // Keep lines perfectly horizontal (y2 = 0)
      line.setAttribute('x1', 0);
      line.setAttribute('y1', 0);
      line.setAttribute('x2', contentX);
      line.setAttribute('y2', 0);
    });
  }
}

customElements.define('product-hotspots', ProductHotspots);
